module.exports = __webpack_public_path__ + "assets/img/home-zszq.dceaf973.png";